// React
import { memo } from 'react'

// Antd
import { Row, Col, Input, Grid } from 'antd'

// Interfaces
import { IBaseTableHeaderProps } from '../interfaces'

// i18n
import { useTranslation } from 'react-i18next'

// Style
import styles from './index.module.scss'

// Components
import { BaseLabel } from 'components'

// Antd - Input
const { Search } = Input

// Antd - Grid
const { useBreakpoint } = Grid

const BaseTableHeader = memo(
  ({
    searchPlaceholder,
    noLeft,
    left,
    titleLeft,
    notUsingDefaultLeft,
    middle,
    right,
    loading,
    onChange,
  }: IBaseTableHeaderProps) => {
    // Translate
    const { t } = useTranslation()
    const { xs } = useBreakpoint()

    /**
     * @description Watch any change in search input
     *
     * @param {string} event
     *
     * @return {void} void
     */
    const onChangeSearch = (event: string): any => {
      if (onChange) onChange({ name: 'searchKeyword', value: event })
    }

    return (
      <Row className="mb-4 lg:mb-8">
        <Col xs={24} sm={24} md={16} lg={16} className="mb-2 md:mb-0">
          <div className="flex flex-col md:flex-row gap-5">
            {/* Render Left */}
            {left ? left : <></>}

            {/* Render Title Left */}
            {titleLeft && (
              <div className="h-full w-full flex flex-col justify-center">
                <BaseLabel label={t(titleLeft)} fontSize={16} className="font-weight-700" />
              </div>
            )}

            {/* Render Default Left */}
            {!notUsingDefaultLeft && (
              <Search
                placeholder={t(searchPlaceholder ? searchPlaceholder : 'app.search')}
                className={styles['custom-search-group']}
                onSearch={onChangeSearch}
                loading={loading}
                style={{ width: !left && !xs ? '50%' : '100%' }}
              />
            )}
          </div>
        </Col>
        <Col xs={24} sm={24} md={4} lg={4}>
          {middle ? middle : <></>}
        </Col>
        <Col xs={24} sm={24} md={4} lg={4}>
          {right ? right : <></>}
        </Col>
      </Row>
    )
  },
)

export { BaseTableHeader }
